import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Chip, Stack, Tooltip } from '@mui/material';
import useErrorHandler from '../../services/error-handler';
import KosaAccountingStore from '../../store/kosa-accounting-store';
import CorrectionDialog from './CorrectionDialog';

const store = new KosaAccountingStore();

//=================================================================================================
const Item = ({ item, onClick }) => {
    const lbl = () => {
        const val = item.unit === 'шт.' ? Math.round(item.quantity) : item.quantity;
        return (
            <>
                {item.name + ' '}
                <strong>({val + item.unit})</strong>
            </>
        );
    };
    return (
        <Tooltip title="Провести корректировку компонента">
            <Chip
                clickable
                size="small"
                label={lbl()}
                color={+item.quantity > +item.min_quantity ? 'success' : 'error'}
                onClick={() => onClick(item)}
            />
        </Tooltip>
    );
};

//=================================================================================================
const KosaAccountingList = () => {
    const errorHandler = useErrorHandler();

    const [correctionDialog, setCorrectionDialog] = useState(null);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            await store.load();
        } catch (e) {
            errorHandler(e);
        }
    };

    const onItemClick = (item) => {
        setCorrectionDialog(item);
    };

    return (
        <>
            <Stack spacing={1} direction="row" useFlexGap sx={{ flexWrap: 'wrap' }}>
                {store.items
                    // .filter((item) => parseInt(item.min_quantity) !== 0)
                    .filter((item) => +item.quantity <= +item.min_quantity && +item.min_quantity !== 0)
                    .map((item) => (
                        <Item key={item.component_id} item={item} onClick={() => onItemClick(item)} />
                    ))}
            </Stack>
            <CorrectionDialog item={correctionDialog} store={store} onClose={() => setCorrectionDialog(null)} />
        </>
    );
};

export default observer(KosaAccountingList);
